import { createFileRoute } from '@tanstack/react-router';
import { WeekAgenda } from '@/features/tasks/agenda/AgendaSettimana';

/**
 * L'Agenda è quel che `/tasks` apre, e sta in una **rotta indice** invece di essere resa a mano
 * dal layout.
 *
 * ⚠️ Il difetto che questo file chiude: il layout la rendeva da sé quando il percorso era
 * `/tasks`, ma quel layout è **solo desktop**. Su telefono `MobileTasks` riceve un `<Outlet/>`,
 * e per `/tasks` quell'outlet non aveva niente da rendere: l'Agenda sul telefono era una
 * schermata vuota. Con la rotta indice la montano entrambi i gusci dallo stesso posto.
 */
export const Route = createFileRoute('/_app/tasks/')({ component: WeekAgenda });
